import { Component, Input } from '@angular/core';
import { AccountingPlanModel } from 'models/generated/Entities.Accounting.AccountingPlan';
import { ProductPlanModel } from 'models/generated/Entities.GormCrm.ProductPlan';
import { Layout } from 'modules/layout';
import { ListView } from 'modules/list-view';
import { CustomDatePipe } from 'pipes/custom-date.pipe';
import { TranslatePipe } from 'pipes/translate.pipe';
import { FormValidationService } from 'services/form-validation.service';
import { LedgerPostsComponent } from './ledger-posts.component';

@Component({
	selector: 'ledger-posts-comparison',
	templateUrl: './ledger-posts-comparison.component.html',
	providers: [FormValidationService],
	imports: [Layout, ListView, LedgerPostsComponent, TranslatePipe, CustomDatePipe]
})
export class LedgerPostsComparisonComponent {

	@Input() productPlans: ProductPlanModel[] = [];
	@Input() accountingPlan?: AccountingPlanModel;

	private _changedTimestamps: Date[] = [];
	@Input()
	set changedTimestamps(timestamps: Date[]) {
		this._changedTimestamps = timestamps;
		if (timestamps.length === 0) return;
		const historicalStates = timestamps.map(timestamp => {
			let state = new HistoricalState;
			state.endTimestamp = timestamp;
			return state;
		});

		historicalStates.push(new HistoricalState);
		this.historicalStates = historicalStates;
	}
	get changedTimestamps() { return this._changedTimestamps; }

	protected historicalStates: HistoricalState[] = [];
	protected selectedStates: HistoricalState[] = [];

	selectState(state: HistoricalState) {
		if (this.selectedStates.indexOf(state) >= 0) {
			this.selectedStates.splice(this.selectedStates.indexOf(state), 1);
		}
		else {
			if (this.selectedStates.length == 0) {
				// If only one state is selected, select the next state as well
				const stateIndex = this.historicalStates.indexOf(state);
				if (stateIndex < this.historicalStates.length - 1) {
					this.selectedStates.push(this.historicalStates[stateIndex + 1]);
				}
			}
			this.selectedStates.push(state);
		}
		this.selectedStates.sort((a, b) => {
			if (a.endTimestamp && b.endTimestamp)
				return new Date(a.endTimestamp).getTime() - new Date(b.endTimestamp).getTime();
			if (a.endTimestamp)
				return new Date(a.endTimestamp).getTime() - new Date().getTime();
			if (b.endTimestamp)
				return new Date().getTime() - new Date(b.endTimestamp).getTime();
			return -1;
		});
	}
}
export class HistoricalState {
	endTimestamp?: Date;
}
